export default `NO ARROWS
skeletal->muscular["supports"]
muscular->respiratory
respiratory->nervous["alerts"]
nervous->immune["activates"]
digestive->nervous
nervous->muscular
digestive->skeletal["nutrients"]
`